import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';

const ActivityCard = ({ variant, src, title, text, links }) => {
  return (
    <Card>
      <Card.Img alt="" variant={variant} src={src} className='img-fluid' />
      <Card.Body>
        <Card.Title as="h3">{title}</Card.Title>
        <Card.Text>{text}</Card.Text>
        <ul>
          {links.map(({ sourceName, source }) => {
            return (
              <li key={sourceName} className='card-link-wrapper'>
                <Card.Link href={source} target='_blank'>
                  {sourceName}
                </Card.Link>
              </li>
            );
          })}
        </ul>
      </Card.Body>
    </Card>
  );
};

export default ActivityCard;

ActivityCard.propTypes = {
  variant: PropTypes.string,
  src: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  links: PropTypes.array,
};
